var _circle, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconProfile01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.5,
  r: 9.25,
  stroke: "#000",
  strokeWidth: 1.5
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "icon_profile_01_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.128 19.764A2.4 2.4 0 0 1 5 19c0-2.21 3.134-4 7-4s7 1.79 7 4q-.001.393-.128.764A9.97 9.97 0 0 1 12 22.5a9.97 9.97 0 0 1-6.872-2.736M12 14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.128 19.764A2.4 2.4 0 0 1 5 19c0-2.21 3.134-4 7-4s7 1.79 7 4q-.001.393-.128.764A9.97 9.97 0 0 1 12 22.5a9.97 9.97 0 0 1-6.872-2.736M12 14a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m5.128 19.764-1.326.45.111.329.252.238zm13.744 0 .963 1.017.252-.238.111-.33zm-12.418-.449A1 1 0 0 1 6.4 19H3.6c0 .42.07.828.202 1.213zM6.4 19c0-.385.286-1.008 1.345-1.613 1.019-.582 2.52-.987 4.255-.987v-2.8c-2.131 0-4.13.49-5.644 1.356C4.88 15.799 3.6 17.176 3.6 19zm5.6-2.6c1.735 0 3.236.405 4.255.987 1.059.605 1.345 1.228 1.345 1.613h2.8c0-1.824-1.281-3.201-2.756-4.044C16.13 14.091 14.132 13.6 12 13.6zm5.6 2.6a1 1 0 0 1-.054.315l2.652.898A3.8 3.8 0 0 0 20.4 19zm.31-.252A8.57 8.57 0 0 1 12 21.1v2.8c3.034 0 5.793-1.187 7.835-3.119zM12 21.1a8.57 8.57 0 0 1-5.91-2.352L4.165 20.78A11.37 11.37 0 0 0 12 23.9zm2.1-10.6a2.1 2.1 0 0 1-2.1 2.1v2.8a4.9 4.9 0 0 0 4.9-4.9zM12 8.4c1.16 0 2.1.94 2.1 2.1h2.8A4.9 4.9 0 0 0 12 5.6zm-2.1 2.1c0-1.16.94-2.1 2.1-2.1V5.6a4.9 4.9 0 0 0-4.9 4.9zm2.1 2.1a2.1 2.1 0 0 1-2.1-2.1H7.1a4.9 4.9 0 0 0 4.9 4.9z",
  mask: "url(#icon_profile_01_svg__a)"
})));
export default SvgIconProfile01;